<script lang="ts" setup>
import MP3DPNavBarVue from './components/MP3DPNavBar.vue';
import Topbar from './components/Topbar.vue';
import Tchat from './components/Tchat.vue';
import Footer from './components/Footer.vue';
import HomepageCartRecupModal from '~/components/homepage/HomepageCartRecupModal.vue';

import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useSettingsStore } from './stores/settings';
import { requirejs } from './modules/require';
import { useMeStore } from './stores/me';
import ClientOnly from './modules/client-only';
import { router } from './router';

const MD_BREAKPOINT = 1023;
const settings = useSettingsStore();
const me = useMeStore();
const props = defineProps<{ onMount: () => void }>();
const showModal = ref(true);

const hasPageAlreadyAFooter = computed(() => settings.meta.hasFooter || false);

const handleResize = () => {
  const container: HTMLElement = document.querySelector('.page-container') as HTMLElement;
  if (!container) {
    return;
  }

  settings.setIsMobileDevice(container.clientWidth <= MD_BREAKPOINT);
};

const displayTermsOfUseAcceptance = async () => {
  await me.waitForMeIsFetched();
  if (!me.isSeller) {
    return;
  }

  const [MarketplaceConnector, TermsOfUseSellerFactory] = await requirejs<[any, any]>([
    'DS/MPFDataProxy/MarketplaceConnector',
    'DS/MPFTcContractComponent/TermsOfUseSellerFactory',
  ]);
  MarketplaceConnector.fetchPromise().then((connector: any) => {
    const termsOfUseSeller = new TermsOfUseSellerFactory({ connector });
    termsOfUseSeller.displayTermsOfUse();
  });
};

const removeOnRoute = router.afterEach(() => {
  if (!me.shouldShowCartRecupModal) {
    showModal.value = false;
  } else {
    me.shouldShowCartRecupModal = false;
  }
});

onMounted(async () => {
  await props.onMount();
  window.addEventListener('resize', handleResize);
  handleResize();
  displayTermsOfUseAcceptance();
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
  removeOnRoute();
});
</script>
<template>
  <div>
    <Topbar />
    <MP3DPNavBarVue />
    <HomepageCartRecupModal v-if="showModal" />
    <div class="page-container flex flex-column">
      <Suspense>
        <RouterView :class="`flex-grow-1 ${String(router.currentRoute.value.name)}-page`" />
        <template #fallback> Loading... </template>
      </Suspense>
      <Tchat />
      <ClientOnly>
        <Footer v-if="!hasPageAlreadyAFooter" />
      </ClientOnly>
    </div>
  </div>
</template>
<style lang="css" scoped>
.page-container {
  overflow-y: auto;
  min-height: calc(100dvh - 86px);
  max-height: calc(100dvh - 86px);
}
</style>
